import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { GcpConnector } from '../../connector';

export const CloudSqlService = IntegrationService.make({
  connector: GcpConnector,
  name: Integration_Service_Names_Enum.CloudSql,
});
